/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
import { CustomSankeyLayerProps, DefaultLink, DefaultNode, SankeyCustomLayer } from '@nivo/sankey';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import CustomSankeyLinks from './CustomSankeyLinks';
import CustomSankeyNodes, { CustomSankeyNode } from './CustomSankeyNodes';

export type Coords = {
  left?: number;
  top?: number;
};

const makeCustomSankey = (): SankeyCustomLayer<DefaultNode, DefaultLink> => {
  const NodeComponent: SankeyCustomLayer<DefaultNode, DefaultLink> = (
    props: CustomSankeyLayerProps<DefaultNode, DefaultLink>
  ) => {
    const { width, links, nodes } = props;

    const [linkHover, setLinkHover] = useState('');
    const [nodeHover, setNodeHover] = useState('');
    const [coords, setCoords] = useState<Coords | null>({});

    const nodeData: Record<string, CustomSankeyNode> = {
      Pending: {
        x: 0,
        y: 16,
        width: 20,
        height: 200,
        label: 'PENDING',
      },
      Escalate: {
        x: width / 4,
        y: 92,
        width: 20,
        height: 130,
        label: 'ESCALATE',
      },
      'Escalate 1': {
        x: (2 * width) / 4,
        y: 142,
        width: 20,
        height: 130,
        label: 'ESCALATE',
      },
      'Reviewer Follow-up': {
        x: (3 * width) / 4,
        y: 80,
        width: 40,
        height: 110,
        label: ['REVIEWER', 'FOLLOW-UP'],
      },
      'Legal Follow-up': {
        x: 50 + (3 * width) / 4,
        y: 200,
        width: 40,
        height: 110,
        label: ['LEGAL', 'FOLLOW-UP'],
      },
      Acceptable: {
        x: width - 20,
        y: -44,
        width: 20,
        height: 125,
        label: 'ACCEPTABLE',
      },
      'Follow-up Complete': {
        x: width - 20,
        y: 117,
        width: 20,
        height: 190,
        label: 'FOLLOW-UP COMPLETE',
      },
    };

    const renderTooltip = (): React.ReactPortal | null => {
      const hoveredNode = nodeHover ? nodes.find((n) => n.id === nodeHover) : null;
      const hoveredLink = linkHover
        ? links.find(
            (l) =>
              linkHover.split('--')[0] === l.source.id && linkHover.split('--')[1] === l.target.id
          )
        : null;

      let tooltipText = '';
      let tooltipValue = '';

      if (hoveredNode) {
        tooltipText = hoveredNode.id;
        tooltipValue = hoveredNode.formattedValue;
      }

      if (hoveredLink) {
        tooltipText = `${hoveredLink.source.id} - ${hoveredLink.target.id}`;
        tooltipValue = hoveredLink.formattedValue;
      }

      if (hoveredLink || hoveredNode) {
        const portal = document.getElementById('tooltip-portal');
        const ttip = (
          <div
            data-testid="tooltip-text"
            style={{
              left: coords?.left || 0,
              top: (coords?.top || 0) - 35,
            }}
            className=" bg-litlingo-off-white p-1 rounded flex items-center shadow-md fixed transform -translate-x-1/2"
          >
            <div className="flex flex-row gap-1 text-body whitespace-no-wrap">
              <span>{tooltipText}:</span>
              <b>{tooltipValue}</b>
            </div>
          </div>
        );
        if (portal) {
          return ReactDOM.createPortal(ttip, portal);
        }
        return null;
      }
      return null;
    };

    return (
      <>
        <CustomSankeyLinks
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          customNodes={nodeData}
          nodeHover={nodeHover}
          hover={linkHover}
          setHover={setLinkHover}
          setCoords={setCoords}
        />

        <CustomSankeyNodes
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          customNodes={nodeData}
          hover={nodeHover}
          setHover={setNodeHover}
          setCoords={setCoords}
        />

        {renderTooltip()}
      </>
    );
  };

  return NodeComponent;
};

export default makeCustomSankey;
